var _defs, _rect, _path, _path2, _path3, _circle, _line, _path4, _path5, _path6, _path7, _path8, _circle2, _path9, _polygon, _path0, _line2, _circle3, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 324 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#e1e6ea;}.cls-3{fill:#f9f9f9;}.cls-4,.cls-5{fill:none;}.cls-4{stroke:#fff;stroke-width:2px;}.cls-4,.cls-5,.cls-6{stroke-linecap:round;stroke-miterlimit:10;}.cls-5{stroke:#3c4650;stroke-width:1.25px;}.cls-6{fill:#ffaa96;stroke:#212c38;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "copy_account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.63,
    y: 55.96,
    width: 58.4,
    height: 99.28,
    rx: 6.66,
    ry: 6.66
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.58,143.18a6.13,6.13,0,0,0,6.13,6.13H295.34a6.13,6.13,0,0,0,6.13-6.13V43a6.13,6.13,0,0,0-6.13-6.13H124.71A6.13,6.13,0,0,0,118.58,43m172.9,93.59a5.18,5.18,0,0,1-5.17,5.18H134.85a5.17,5.17,0,0,1-5.17-5.17V52.78a5.17,5.17,0,0,1,5.17-5.17H286.31a5.17,5.17,0,0,1,5.17,5.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310,169.31c-1.95-2.22-4.26-5-5.48-6.47-2.56-3.14-4.43-4.48-8.71-4.48H125.23c-4.28,0-6.15,1.34-8.71,4.48-1.22,1.42-3.53,4.25-5.48,6.47s-1.84,4.76,4.39,4.76H305.58C311.82,174.07,311.92,171.53,310,169.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.47,40.41V153.84a4.66,4.66,0,0,0,4.66,4.66h57a4.66,4.66,0,0,0,4.66-4.66V40.41a4.67,4.67,0,0,0-4.66-4.67h-57A4.67,4.67,0,0,0,2.47,40.41Zm8.18,18.85a3.93,3.93,0,0,1,3.93-3.93H59.11A3.93,3.93,0,0,1,63,59.25v78.46a3.93,3.93,0,0,1-3.93,3.93H14.58a3.93,3.93,0,0,1-3.93-3.93Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 36.41,
    cy: 149.73,
    r: 4.27
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 32.02,
    y1: 45.62,
    x2: 40.4,
    y2: 45.62
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2.48,113.58v-72A4.66,4.66,0,0,1,7.14,37s42.74.08,57,0c2,0,6.17-.07,6.17,5V56.72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2.47,104.34V157a4.66,4.66,0,0,0,4.67,4.66h57A4.66,4.66,0,0,0,68.78,157V140"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M120.55,75.42V44.52a6.13,6.13,0,0,1,6.13-6.13H297.31a6.13,6.13,0,0,1,6.13,6.13V107"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119.72,131.35V144.7a6.13,6.13,0,0,0,6.13,6.13h88.38"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M320,173.75c-2.67-3-5.83-6.9-7.5-8.84-3.5-4.3-6.06-6.13-11.91-6.13H120.89c-5.85,0-8.41,1.83-11.91,6.14-1.67,1.93-4.83,5.8-7.5,8.84s-2.52,6.51,6,6.51H314C322.52,180.26,322.66,176.79,320,173.75Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 37.32,
    cy: 98.46,
    r: 20.19
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,100.69h1.08c1.48,0,1.48-.9,1.48-1.86V96.22h-4v2.61C26.5,99.83,26.5,100.69,28,100.69Zm-.09-3.1h1.26v1.73H27.9Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "45.9 101.49 48.66 101.49 48.66 100.03 47.36 100.03 47.36 97.69 50.44 97.69 50.44 96.22 45.9 96.22 45.9 101.49"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.73,95.36h7.71V93.9H24.2v4.94c0,2.81,1.2,4.17,3.66,4.17h1.35c2.42,0,3.64-1.45,3.64-4.29v-1H43.58V100h-1.4v1.46H45V96.22H31.39v2.5c0,2.35-.87,2.83-2.18,2.83H27.86c-1.39,0-2.2-.44-2.2-2.71V95.36H42.73"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 58.15,
    y1: 98.08,
    x2: 210.74,
    y2: 98.08
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 208.46,
    cy: 98.31,
    r: 20.19
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.17,96.1l0-2.41c0-2,0-3.63-2.93-3.6l-2.12,0c-2.89,0-2.87,1.8-2.85,3.67l0,2.41-1.81,0,.06,5.08c0,2.84.06,5.3,4.28,5.25l3.1,0c4.22,0,4.19-2.62,4.16-5.34L214,96.08Zm-5.22-3.31,2.46,0,0,3.36-2.46,0Zm2.55,7.28-.36.77.39,2.49-2.47,0,.34-2.44-.37-.82s-.14-1,1.22-1S209.49,100.08,209.49,100.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAccount);
export default __webpack_public_path__ + "static/media/copy_account.dea4a19a76ee0277dcbc76df4c8bdb8b.svg";
export { ForwardRef as ReactComponent };